import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import { ViewProps } from 'approot/activity-builder/components/columns/columns.constants';
import * as Styled from 'approot/activity-builder/components/columns/columns.style';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/columns/settings/column-settings.utils';
import { ComponentEventData } from 'approot/activity-builder/present/activity-builder-present-data-tracking.utils';
import ActivitySampleColumnsComponents from './activity-sample-columns-components';
import type { InteractiveLessonSectionComponentFragment } from '../../lesson-builder.graphql.generated';

const ActivitySampleColumns = ({
  columns,
  columnProperties,
  contentId,
  eventTrackingData,
  openModal,
}: ViewProps & {
  eventTrackingData?: ComponentEventData;
  openModal: (component: InteractiveLessonSectionComponentFragment) => void;
}) => {
  const { isZoomToFit } = useActivityBuilderPresentContext();
  return (
    <Styled.ColumnsContainer
      $colours={getAppliedColour(columnProperties?.style)}
      $showBackground={isBackgroundApplied(columnProperties?.style)}
      $showBorder={isBorderApplied(columnProperties?.style)}
      $turnOffResponsive={isZoomToFit}
    >
      {columns?.map(column => (
        <Styled.ColumnsColumn
          key={column.columnId}
          $colspan={column.colspan}
          $alignment={column.alignment}
          $colours={getAppliedColour(column.style)}
          $showBorder={isBorderApplied(column.style)}
          $showBackground={isBackgroundApplied(column.style)}
          $turnOffResponsive={isZoomToFit}
        >
          <ActivitySampleColumnsComponents
            column={column}
            contentId={contentId}
            eventTrackingData={eventTrackingData}
            openModal={openModal}
          />
        </Styled.ColumnsColumn>
      ))}
    </Styled.ColumnsContainer>
  );
};

export default ActivitySampleColumns;
